import React, { PropTypes, Component } from 'react'
import classnames from 'classnames'
import Table from 'components/Table'
import Button from 'components/Button'
import Avatar from 'components/Avatar'
import { IconGreenTick } from 'icons'

const styles = Object.assign(
  {},
  require('../../PartnerPlan.scss'),
  require('components/Table/Table.scss'),
)

const headerStyles = classnames(
  styles.table.flush,
  styles.unSortable,
)

class Progress extends Component {
    static propTypes = {
      handleUpload: PropTypes.func.isRequired,
      steps: PropTypes.instanceOf(Array).isRequired,
    }

  _handleChange = (name, value) => { }

  render() {
    const getLineStyles = () => {
      return {
        height: '20px',
        // marginTop: isAvatar ? '6px' : '6px',
        marginTop: '6px',
        marginLeft: '16px',
        marginBottom: '6px',
      }
    }

    return (
      <Table>
        <tbody>
          {this.props.steps.map(({
                key, label, desc, desc2, isDone, highlight = false, isCurrent, actions,
                }, index) => (
                  <tr key={key}>
                    <td
                      className={styles.narrowRight}
                      style={
                      {
                        verticalAlign: 'top', align: 'center', paddingRight: 0, maxWidth: 40,
                      }
                      }
                    >
                      {isDone ? <IconGreenTick height="31" width="31" /> : <Avatar className={isCurrent ? styles.greenAvatar : styles.greyAvatar} title={(index + 1).toString()} />}
                      {(index !== (this.props.steps.length - 1)) && <div className={styles.line} style={getLineStyles(!isDone)} />}
                    </td>
                    <td className={styles.narrowLeft20}>
                      <div className={isDone && highlight ? `${styles.stepDetailsGreen}` : `${styles.stepDetails}`}>
                        <div>
                          {label}
                        </div>
                        <div className={styles.stepStatus}>{desc}</div>
                        { desc2 && desc2 !== null ? <div className={styles.stepStatus2}>{desc2}
                        </div> : null }
                      </div>
                    </td>
                    <td className={classnames(styles.narrowLeft20, styles.tablefonts)} />
                    <td className={classnames(styles.narrowLeft20, styles.tablefonts, styles.actions)}>
                      { // (isCurrent || isDone) && actions.map(action => <Button type="flat" {...action} />)
                      (isCurrent || isDone) && actions.map(action => <Button type="flat" {...action} />)}
                    </td>
                  </tr>
            ))}
          <tr key="99"><td className={styles.narrowHeight10} /></tr>
        </tbody>
      </Table>
    )
  }
}

export default Progress



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/Progress.js